import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Home from '../../pages/Home';
import Wrapper from '../wrapper/Wrapper';
import WorkWithUsPage from '../../pages/WorkWithUs';
import EmbeddedProgramming from '../../pages/EmbeddedProgramming';
import CustomCircuitDesigns from '../../pages/CustomCircuitDesigns';
import PCBDesign from '../../pages/PCBDesign';
import Advertisement from '../../pages/Advertisement';
import LogoDesign from '../../pages/LogoDesign';
import GraphicDesign from '../../pages/GraphicDesign';
import CadDesign from '../../pages/CadDesign';
import AppDevelopmentPage from '../../pages/AppDevelopmentPage';
import WebDevelopmentPage from '../../pages/WebDevelopmentPage';
import BlogDetails from '../../pages/BlogDetails';
import Blogs from '../../pages/Blogs';
import ThreeDPrinting from '../../pages/ThreeDPrinting';
import NotFound from '../../pages/NotFound';
export default function AppRoutes() {
  return <Routes><Route path="/" element={<Wrapper />}>
    <Route index element={<Home />} />
    <Route path="work-with-us" element={<WorkWithUsPage />} />
    <Route path="embedded-programming" element={<EmbeddedProgramming />} />
    <Route path="circuit-design" element={<CustomCircuitDesigns />} />
    <Route path="pcb-design" element={<PCBDesign />} />
    <Route path="app-development" element={<AppDevelopmentPage />} />
    <Route path="web-development" element={<WebDevelopmentPage />} />
    <Route path="advertisement" element={<Advertisement />} />
    <Route path="cad-design" element={<CadDesign />} />
    <Route path="graphic-design" element={<GraphicDesign />} />
    <Route path="logo-design" element={<LogoDesign />} />
    <Route path="3d-printing" element={<ThreeDPrinting />} />
    <Route path="blogg" element={<Blogs />} />
    <Route path="blogg/:id" element={<BlogDetails />} />
    <Route path="animated-video" element={<Navigate to="/#services" replace />} />
    <Route path="web-template/:id" element={<Navigate to="/web-development" replace />} />
    <Route path="app-template/:id" element={<Navigate to="/app-development" replace />} />
    <Route path="*" element={<NotFound />} />
  </Route></Routes>;
}
